import {
  MDBCard,
  MDBCardBody,
  MDBCardImage,
  MDBCardText,
  MDBCardTitle,
  MDBCol,
} from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import Mark from "./Images/Mark.jpg";
import Sarah from "./Images/Sarah.jpeg";
import "./References.css";

function References() {
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => setHeight(window.innerHeight);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <div className="container p-3 mb-5 bg-body rounded">
        <div
          className="section-title"
          style={{ marginBottom: "1rem", marginTop: "4rem" }}
        >
          <h2>References</h2>
        </div>
        <div id="demo" className="carousel slide" data-bs-ride="carousel">
          <div className="carousel-inner" style={{ marginBottom: "10rem" }}>
            <div className="carousel-item active">
              <MDBCol className="carousel-item1">
                <MDBCard className="refer-card">
                  <MDBCardImage
                    className="references-img obj-fit"
                    src={Mark}
                    alt="Hollywood Sign on The Hill"
                    position="top"
                  />
                  <MDBCardBody className="refer-body">
                    <MDBCardTitle className="refer-name refer-name-cus">
                      Mark Johnson, CEO of BNS
                    </MDBCardTitle>
                    <h5 className="sub-title sub-title-cus">
                      - Client Testimonial
                    </h5>
                    <MDBCardText className="refer-description refer-description-cus">
                      <sup>
                        <i className="fas fa-quote-left quote-cus"></i>
                      </sup>
                      &nbsp;&nbsp;&nbsp;Working with Ishan was an absolute
                      pleasure. He delivered exceptional results and went above
                      and beyond our expectations. His attention to detail,
                      creativity, and strong communication skills made the
                      collaboration seamless. I highly recommend Ishan for any
                      future projects.&nbsp;&nbsp;&nbsp;
                      <sup>
                        <i className="fas fa-quote-right quote-cus"></i>
                      </sup>
                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>
            </div>

            <div className="carousel-item">
              <MDBCol className="carousel-item1">
                <MDBCard className="refer-card">
                  <MDBCardImage
                    className="references-img obj-fit"
                    src={Sarah}
                    alt="..."
                    position="top"
                  />
                  <MDBCardBody className="refer-body">
                    <MDBCardTitle className="refer-name refer-name-cus">
                      Sarah Thompson, Senior Manager at ANS Corporation
                    </MDBCardTitle>
                    <h5 className="sub-title sub-title-cus">
                      - Supervisor Reference
                    </h5>
                    <MDBCardText className="refer-description refer-description-cus">
                      <sup>
                        <i className="fas fa-quote-left quote-cus"></i>
                      </sup>
                      &nbsp;&nbsp;&nbsp;I had the privilege of managing Ishan
                      during his time at our company. He consistently
                      demonstrated a high level of professionalism,
                      problem-solving skills, and the ability to meet deadlines.
                      His contributions greatly impacted our team's success. I
                      confidently recommend Ishan as a valuable asset to any
                      organization.&nbsp;&nbsp;&nbsp;
                      <sup>
                        <i className="fas fa-quote-right quote-cus"></i>
                      </sup>
                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>
            </div>
          </div>

          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#demo"
            data-bs-slide="prev"
          >
            <i className="fas fa-caret-left"></i>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#demo"
            data-bs-slide="next"
          >
            <i className="fas fa-caret-right"></i>
          </button>
        </div>
      </div>
    </>
  );
}

export default References;
